module.exports = __webpack_public_path__ + "static/background-eb4c710c884ec51231b46ce5eba4885e.jpg";